import { Router } from "@angular/router";
import { Component, OnInit, Input, AfterViewInit } from "@angular/core";
import { EmbryoService } from "src/app/Services/Embryo.service";
import { StaticPagesService } from "src/app/Services/static-pages.service";
import { SwiperConfigInterface } from "ngx-swiper-wrapper";
import { MarketingService } from "src/app/Services/marketing.service";

@Component({
    selector: "embryo-CtaGroup",
    templateUrl: "./CTA-Group.component.html",
    styleUrls: ["./CTA-Group.component.scss"],
})
export class CTAGroupComponent implements OnInit {
    bannerTypes = [
        { id: 0, name: "none" },
        { id: 1, name: "Product" },
        { id: 2, name: "Subcategory" },
        { id: 3, name: "Medical" },
        { id: 4, name: "Brand" },
        { id: 5, name: "Custom List" },
        { id: 6, name: "Category" },
        { id: 7, name: "Link" },
        { id: 8, name: "vendor" },
    ];
    // callToActionArray: any = [
    //    {
    //       img_path: 'assets/images/mobile.jpg',
    //       route : '/products/gadgets/12'
    //    },
    //    {
    //       img_path: 'assets/images/sports.jpg',
    //       route : '/products/men/3'
    //    },
    //    {
    //       img_path: 'assets/images/headphone.jpg',
    //       route : '/products/gadgets/11'
    //    },
    //    {
    //       img_path: 'assets/images/t-shirts.jpg',
    //       route : '/products/men/5'
    //    },
    //    {
    //       img_path: 'assets/images/watch.jpg',
    //       route : '/products/gadgets/14'
    //    },
    //    {
    //       img_path: 'assets/images/shoes.jpg',
    //       route : '/products/men/6'
    //    }
    // ];

    @Input() homePageDataCustomAds: any;
    @Input() index = 1;
    lang: any;
    smallSwiperConfig: any = {};
    environmentVariables: any;
    public config: SwiperConfigInterface = {};
    SwiperConfig: any = {};
    
    active_customAds:any;
    constructor(
        private router: Router,
        public embryoService: EmbryoService,
        private pagesService: StaticPagesService,
        private marketingService: MarketingService,

    ) {
        this.embryoService.emitLang.subscribe((lang: any) => {
            this.lang = lang;
        });
        this.pagesService.getenvConfig().subscribe((res: any) => {
            this.environmentVariables = res;
        });

 
   this.SwiperConfig = {
            slidesPerView: 7,
            spaceBetween: 16,
            slidesPerGroup:1,
            keyboard: true,
            navigation: this.environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE  ? true : false ,
            loop: this.environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE  ? true : false ,
            // navigation: true ,
            // loop: true ,
            pagination: false,
            grabCursor: true,
            responsive:true,
            preloadImages: false,
            lazy: true,
            autoplay: {
                delay: 6000,
                disableOnInteraction: false,
            },
            speed: 500,
            effect: "slide",
            breakpoints: {
                320: {
                    slidesPerView: this.environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE  ? 2 : 2.5,
                },
                480: {
                     slidesPerView: this.environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE ? 2 : 2.5,
                },
                600: {
                   slidesPerView: this.environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE   ? 2 : 2.5,
                },
                960: {
                    slidesPerView: this.environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE  ? 3 : 3.5,
                },
                1280: {
                    slidesPerView: this.environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE  ? 4 : 4.5,
                },
                1500: {
                   slidesPerView: this.environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE   ? 4 : 4.5,
                },
            },
        };
    }

    ngOnInit() {
      // console.log(this.homePageDataCustomAds);
      
        if (this.homePageDataCustomAds.length) {
            this.active_customAds=this.homePageDataCustomAds.filter((el:any)=>{
        return el.active==1;
      })
            this.active_customAds.forEach((element: any) => {
                if (element.item_data && element.item_data.name != undefined) {
                    element.nameRouter = encodeURIComponent(
                        element.item_data.name.replace(/\s/g, "-")
                    );
                }
            });
            if(this.environmentVariables?.ENABLE_CUSTOM_ADS_INFINITE){
                this.active_customAds =this.active_customAds.concat(this.active_customAds)
            }
            // else{
            //   document.querySelector('swiper-wrapper')?.classList
            // }
              
          }
    }
 
    bannerRouting(slide: any , indexImage:any) {

        if (slide.type === 0 || slide.type === null) {
            return;
        } else if (slide.type === 1) {
            this.router.navigateByUrl(
                "/" +
                    this.lang +
                    `/products/` +
                    (slide.link
                        ? slide.link
                        : slide.name +
                          "/" +
                          slide.item_id +
                          "?variant=" +
                          slide.item_id)
            );
        } else if (slide.type > 1 && slide.type <= 6) {
            const queryParams: any = {};
            if (slide.type === 2) {
                queryParams.sub_category_id = slide.item_id;
            }
            if (slide.type === 4) {
                queryParams.brand_id = slide.item_id;
            }
            if (slide.type === 5) {
                queryParams.list_ids = slide.item_id;
            }
            if (slide.type === 6) {
                queryParams.category_id = slide.item_id;
            }
            this.router.navigate(["/" + this.lang + "/products"], {
                queryParams: queryParams,
            });
        } else {
            if (slide.type === 7 && !slide.extrnal) {
                window.open(slide.link, "_self");
            } else {
                window.open(slide.link, "_blank");
            }
        }
        // switch (data.type) {
        //   case null:
        //     return;
        //   case 1:
        //     this.router.navigate(["/products/" + data.name, data.item_id]); // product

        //     break;
        //   case 2:
        //     this.router.navigate(["/products"], {
        //       queryParams: { sub_category_id: data.item_id }
        //     }); // category

        //     break;
        //   case 3:
        //     this.router.navigate(["/products"], {
        //       queryParams: { category_id: data.item_id }
        //     });
        //     break;
        //   case 4:
        //     this.router.navigate(["/products"], {
        //       queryParams: { brand_id: data.item_id }
        //     }); // category
        //     break;
        //   case 5:
        //     this.router.navigate(["/products"], {
        //       queryParams: { list_ids: data.item_id }
        //     }); // custom list
        //     break;
        //   default:
        //   // code block
        // }
        this.onGA4PromotionClickEvent(slide, indexImage)

    }

    onGA4PromotionClickEvent(data:any, indexImage = 1){
        console.log('data', data)
        console.log('index', this.index)
        let data_refactor = {
            promotion_id:data.id ?? null,
            promotion_name:data.name ?? null,
            promotion_position:`${this.index}.${indexImage+1}`,
            promotion_type:this.bannerTypes.filter((item:any) => item.id === data.type)[0].name,
        }
        console.log('data_refactor',data_refactor )
        this.marketingService.GA4PromotionClickEvent(data_refactor)
    }


 
}
